/* eslint-disable @typescript-eslint/ban-ts-ignore */

import React, { useState, useMemo, ReactNode, useContext } from "react";

import { Preview } from "@creatomate/preview";
// @ts-ignore
import { SelectableGroup } from "react-selectable";

import { ElementPlacement } from "chq";
import { ActiveElementContext } from "./context/ActiveElementContext";
import { DragContext } from "./context/DragContext";

interface SelectableElementsProps {
  children: ReactNode;
  preview: Preview;
}

const SelectableElements: React.FC<SelectableElementsProps> = ({ children, preview }) => {
  const { isDragging } = useContext(DragContext);

  const [activeElementsDrag, setActiveElementsDrag] = useState<boolean>(false);
  const [activeElementWasDrag, setActiveElementWasDrag] = useState<boolean>(false);
  const [activeElementsPlacement, setActiveElementsPlacement] = useState<ElementPlacement>({
    time: -1, duration: -1
  });
  const [activeElementTransition, setActiveElementTransition] = useState<number>(0);
  const [activeElementTrim, setActiveElementTrim] = useState<boolean>(false);
  const [allowClick, setAllowClick] = useState<boolean>(true);

  const activeElementContext = {
    drag: activeElementsDrag,
    setDrag: setActiveElementsDrag,
    placement: activeElementsPlacement,
    setPlacement: setActiveElementsPlacement,
    transition: activeElementTransition,
    setTransition: setActiveElementTransition,
    wasDrag: activeElementWasDrag,
    setWasDrag: setActiveElementWasDrag,
    trim: activeElementTrim,
    setTrim: setActiveElementTrim,
    allowClick,
    setAllowClick
  };

  const contextValue = useMemo(
    () => activeElementContext,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeElementsDrag, activeElementsPlacement, activeElementTransition,
      activeElementWasDrag, activeElementTrim, allowClick]
  );

  const handleSelection = (items: any[]) => {
    setActiveElementTrim(trim => {
      if (!activeElementsDrag && !trim) {
        setAllowClick(false);
        preview.setActiveElements([...items]);
      }
      return trim;
    });
  };

  const handleNoneItemClick = () => {
    setAllowClick(true);
    if (!document.querySelector(".RightClick-container")) preview.setActiveElements([]);
  };

  return (
    <div className="Selectable-Content">
      <SelectableGroup
        className="SelectableGroup"
        enabled={!isDragging}
        tolerance={0}
        onSelection={handleSelection}
        onNonItemClick={handleNoneItemClick}
      >
        <ActiveElementContext.Provider value={contextValue}>
          {children}
        </ActiveElementContext.Provider>
      </SelectableGroup>
    </div>
  );
};

export default SelectableElements;
